export default __webpack_public_path__ + "27344d8bf35c9a284b5832fb0594c2e9.svg";